import BannerAdsImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Img01.png";
import BannerAdsImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Img02.png";
import BannerAdsImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Img03.png";
import BannerAdsImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Img04.png";
import BannerAdsPortraitImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img01.png";
import BannerAdsPortraitImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img02.png";
import BannerAdsPortraitImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img03.png";
import BannerAdsPortraitImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img04.png";
import BannerAdsPortraitImg05 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img05.png";
import BannerAdsPortraitImg06 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/BannersandDisplayAds/BannerAds-Portrait-Img06.png";
import SMPImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/SocialMediaPosts/SMP-Img01.png";
import SMPImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/SocialMediaPosts/SMP-Img02.png";
import JPJImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img01.png";
import JPJImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img02.png";
import JPJImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img03.png";
import JPJImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img04.png";
import JPJImg05 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img05.png";
import JPJImg06 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/JPJ-Img06.png";
import PNGImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img01.png";
import PNGImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img02.png";
import PNGImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img03.png";
import PNGImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img04.png";
import PNGImg05 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img05.png";
import PNGImg06 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/PNG-Img06.png";
import GIFImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img01.png";
import GIFImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img02.png";
import GIFImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img03.png";
import GIFImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img04.png";
import GIFImg05 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img05.png";
import GIFImg06 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductsImages/GIF-Img06.png";
import PVImg01 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductVideos/PV-Img01.png";
import PVImg02 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductVideos/PV-Img02.png";
import PVImg03 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductVideos/PV-Img03.png";
import PVImg04 from "../../../../assets/images/AffliliatePortal/PromotionalMaterials/ProductVideos/PV-Img04.png";


export const BannersDisplayAdsLandscapeData = [
    { image: BannerAdsImg01 },
    { image: BannerAdsImg02 },
    { image: BannerAdsImg03 },
    { image: BannerAdsImg04 },
];

export const BannersDisplayAdsPortraitData = [
    { image: BannerAdsPortraitImg01 },
    { image: BannerAdsPortraitImg02 },
    { image: BannerAdsPortraitImg03 },
    { image: BannerAdsPortraitImg04 },
    { image: BannerAdsPortraitImg05 },
    { image: BannerAdsPortraitImg06 },
];

export const socialMediaPosts = [
    {
        id: 1,
        image: SMPImg01,
        caption: "🎉 Exciting News! 🎉 Discover the latest gadget every tech enthusiast needs! Introducing the XYZ Smartwatch - your ultimate fitness companion. Track your workouts, monitor your heart rate, and stay connected on-the-go. Get yours now and revolutionize your fitness journey! 💪",
        link: "http://smart-watch.maelano.com/?affcode=955437_nydorbi0",
        hashtags: ["#SmartTech", "#FitnessGoals", "#WearableTech", "#FitnessTracker", "#XYZSmartwatch"],
    },
    {
        id: 2,
        image: SMPImg02,
        caption: "🎉 Exciting News! 🎉 Discover the latest gadget every tech enthusiast needs! Introducing the XYZ Smartwatch - your ultimate fitness companion. Track your workouts, monitor your heart rate, and stay connected on-the-go. Get yours now and revolutionize your fitness journey! 💪",
        link: "http://smart-watch.maelano.com/?affcode=955437_nydorbi0",
        hashtags: ["#SmartTech", "#FitnessGoals", "#WearableTech", "#FitnessTracker", "#XYZSmartwatch"],
    }
];

export const jpjImagesData = [
    { image: JPJImg01 },
    { image: JPJImg02 },
    { image: JPJImg03 },
    { image: JPJImg04 },
    { image: JPJImg05 },
    { image: JPJImg06 },
];

export const pngImagesData = [
    { image: PNGImg01 },
    { image: PNGImg02 },
    { image: PNGImg03 },
    { image: PNGImg04 },
    { image: PNGImg05 },
    { image: PNGImg06 },
];

export const gifImagesData = [
    { image: GIFImg01 },
    { image: GIFImg02 },
    { image: GIFImg03 },
    { image: GIFImg04 },
    { image: GIFImg05 },
    { image: GIFImg06 },
];

export const productVideoImagesData = [
    { image: PVImg01 },
    { image: PVImg02 },
    { image: PVImg03 },
    { image: PVImg04 },
];
